import {PlaceholderComponent} from '../shared/placeholder.component';
import {DrawingFormComponent} from './drawing-form.component';
import {NgModule} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';
import {dynamicStateConfigFn, Ng2DynamicStateDeclaration} from '@ngx-ivengi/locale';

export let CHILD_STATES: Ng2DynamicStateDeclaration[] = [
  {
    name: 'building.edit.floor.edit.drawing',
    abstract: true,
    component: PlaceholderComponent,
    future: true,
    data: {
      pageTitle: 'states.drawing.pageTitle',
      scopes: ['drawing:read']
    }
  },
  {
    name: 'building.edit.floor.edit.drawing.add',
    component: DrawingFormComponent,
    future: true,
    data: {
      pageTitle: 'states.drawing.add.pageTitle',
      scopes: ['drawing:create']
    }
  },
  {
    name: 'building.edit.floor.edit.drawing.edit',
    component: DrawingFormComponent,
    future: true,
    data: {
      pageTitle: 'states.drawing.edit.pageTitle',
      scopes: ['drawing:update']
    }
  }
];

@NgModule({
  imports: [
    UIRouterModule.forChild({
      states: CHILD_STATES,
      config: dynamicStateConfigFn
    }),
    TranslateModule
  ],
  exports: [UIRouterModule]
})
export class DrawingRoutingModule {}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/drawing/drawing.routes.ts